
import React, {Component} from 'react'
import { GiRotaryPhone } from "react-icons/gi";
import Rating from '../../../components/rating/rating';    

var configurationManager = require('../../../utils/config/configurationManager.js');
const themeUtil = require('../../../utils/view/themeUtil.js');
var translator = require('../../../utils/translator/translator.js');
var dateUtil = require('../../../utils/dateUtil/dateUtil');

class CLINotificationCard extends Component 
{
    render()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        return <div style={{border:'1px solid #686868'}}>
                    <table width="100%">
                        <tr>
                            <td align="center">
                                <div style={{paddingTop:'5px', paddingBottom:'5px', background:'var(--colors-primary)', color:'var(--colors-white)'}}>
                                    <table>
                                        <tr>
                                            <td>
                                                <GiRotaryPhone size={30}/>
                                            </td>
                                            <td>
                                                <div style={{marginLeft:'5px', fontSize:'1.5rem'}}>{translator.getLabel("incoming_call")}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <div style={{marginTop:'10px'}}>
                                    {this.renderCustomer()}
                                </div>
                            </td>
                        </tr>
                </table>
            </div>
    }

    renderCustomer()
    {
        let cliDetails = this.props.notification.payload;

        let component = null;
        if (cliDetails.customer == null)
        {
            component = <div>
                            <div style={{fontSize:'1.2rem', color:'var(--colors-primary)', textAlign:'center'}}>{cliDetails.cliIncomingNumber}</div>
                            <div style={{textAlign:'center'}}>{translator.getLabel("new_customer")}</div>
                        </div>
        }
        else
        {

            const customer = cliDetails.customer;
            const rating = customer.profile ? customer.profile.rating : null;
            
            component = <div className='d-flex flex-column'>
                            <div className='d-flex flex-row justify-content-center align-content-center'>
                                <div style={{textAlign:'center', fontSize:'1.2rem'}}>{customer.name}</div>
                                <div style={{marginLeft:'5px', marginTop:'0px'}}><Rating rating={rating}></Rating></div>
                            </div>
                            <div style={{fontSize:'1.2rem', color:'var(--colors-primary)', textAlign:'center'}}>{cliDetails.customer.phoneNumber}</div>
                        </div>
        }

        return  <div className='d-flex flex-column'>
                    {component}
                    <div style={{textAlign:'end', fontSize:'0.8rem', color:'var(--colors-text-light)', marginRight:'10px'}}>
                        {dateUtil.formatDate(this.props.notification.creationDateTime, "ddd DD MMM, HH:mm")}
                    </div>
                </div>;
        
    }
}

export default CLINotificationCard